<template>
  <el-menu :collapse="isCollapsed" :router="true" :collapse-transition="false" :unique-opened="true">
    <el-menu-item
      v-for="item in items"
      :index="item.name"
      :key="item.id"
      :route="item.link"
      :class="{ 'is-active--custom': $route.path.includes(item.name) }"
      @click="item.clickHandler"
    >
      <span slot="title" v-if="!item.children.length" v-html="$t(item.title)"></span>
      <i class="material-icons m-r-1" v-if="!item.children.length">{{ item.icon.name }}</i>
    </el-menu-item>
  </el-menu>
</template>

<script>
import MenuMixin from '@/shared/mixins/menu';

export default {
  name: 'AppNavigationSecondary',

  mixins: [MenuMixin],

  computed: {
    isCollapsed() {
      return this.$store.state.menu.collapse;
    }
  },

  data() {
    return {
      itemIsInPath: false,
      items: [
        {
          id: 1,
          title: 'Settings',
          name: 'settings',
          link: {
            path: '/settings'
          },
          icon: {
            name: 'settings'
          },
          clickHandler: function() {},
          children: []
        },
        {
          id: 2,
          title: 'Support & FAQ',
          name: 'support',
          link: {
            path: '/support/faq'
          },
          icon: {
            name: 'help'
          },
          clickHandler: function() {},
          children: []
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
